import * as actionTypes from './actionTypes';
import { JobModel } from '@app/src/views/StepOne/form/models/job';

interface State {
  data: JobModel[];
  isFetching: boolean;
  error: boolean;
  selected: string;
  message: string;
  lastWordFound: string;
}

const initialState: State = {
  data: [],
  isFetching: false,
  error: false,
  selected: '',
  message: '',
  lastWordFound: ''
}

export const job = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_JOB_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_JOB_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_JOB_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    case actionTypes.SET_JOB_MESSAGE:
      return {
        ...state,
        message: action.message
      }
    case actionTypes.CLEAR_JOB_MESSAGE:
      return {
        ...state,
        message: ''
      }
    case actionTypes.CLEAR_JOB_DATA:
      return {
        ...state,
        data: [],
        message: ''
      }
    case actionTypes.SET_JOB_SELECTED:
      return {
        ...state,
        selected: action.selected
      }
    case actionTypes.CLEAR_JOB_SELECTED:
      return {
        ...state,
        selected: ''
      }
    case actionTypes.SET_JOB_WORD_FOUND:
      return {
        ...state,
        lastWordFound: action.word
      }
    default:
      return state;
  }
}
